import * as React from 'react';
import { ProgressBar } from '@grandvisionhq/common';

const ShippingThreshold = ({ price , freeShippingThreshold , labels  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__shipping-threshold",
        "data-t": "cart-totals-shipping-threshold"
    }, /*#__PURE__*/ React.createElement(ProgressBar, {
        value: price,
        max: freeShippingThreshold
    }), /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__shipping-threshold--text",
        "data-t": "cart-totals-shipping-threshold-text"
    }, price < freeShippingThreshold ? labels.freeShippingRemainder : labels.freeShippingReached));
};

export { ShippingThreshold };
//# sourceMappingURL=ShippingThreshold.js.map
